/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { appRoutes } from '../src/app/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from '../src/app/environments/environment';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { apiReducer } from './app/state/reducer';
import { ApiEffects } from './app/state/effects';
import { authRefreshInterceptor } from './app/interceptors/auth-refresh.interceptor';
import { dpopInterceptor } from './app/interceptors/dpop.interceptor';

registerLicense(environment.syncfusionLicenceKey);

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(appRoutes),
    // Order matters: dpopInterceptor AFTER authRefreshInterceptor so every request
    // (including the retry after a token refresh) leaves with a fresh DPoP proof
    // bound to the token actually being sent.
    provideHttpClient(withInterceptors([authRefreshInterceptor, dpopInterceptor])),
    provideStore({ api: apiReducer }),
    provideEffects([ApiEffects])
  ],
})
  .catch(err => console.error(err));
